export enum TripType {
  Single = 1,
  Annual = 2,
}
